//@ts-check

if (!customElements.get("ff-variants-select")) {
  class FfVariantsSelect extends HTMLElement {
	/**
	 * @type {HTMLLIElement[]}
	 */
	ffOptionsEl = [];

	constructor() {
	  super();
	  this.style.pointerEvents = "none";

	  /**
	   * @type {NodeListOf<HTMLButtonElement>}
	   */
	  this.ffVariantsBtn = (() => {
		/**
		 * @type {NodeListOf<HTMLButtonElement>}
		 */
		const ffVariantsBtn = document.querySelectorAll(
		  `[data-ff-variants-select-id='${this.id}']`
		);

		if (ffVariantsBtn.length > 0) {
		  return ffVariantsBtn;
		} else {
		  throw new Error("Missing variants buttons");
		}
	  })();

	  /**
	   * @type {HTMLInputElement}
	   */
	  this.ffInput = (() => {
		/**
		 * @type {HTMLInputElement | null}
		 */
		const ffInput = document.querySelector(
		  this.dataset.ffInputSelector || ""
		);

		if (ffInput) {
		  return ffInput;
		} else {
		  throw new Error("Missing input");
		}
	  })();

	  /**
	   * @type {HTMLDivElement}
	   */
	  this.ffOptionsContainerEl = (() => {
		/**
		 * @type {HTMLDivElement | null}
		 */
		const ffOptionsContainerEl = this.querySelector(
		  "[data-ff-variants-select-options]"
		);

		if (ffOptionsContainerEl) {
		  return ffOptionsContainerEl;
		} else {
		  throw new Error("Missing options container");
		}
	  })();

	  /**
	   * @type {NodeListOf<HTMLButtonElement>}
	   */
	  this.ffOpenCloseEl = (() => {
		/**
		 * @type {NodeListOf<HTMLButtonElement>}
		 */
		const ffOpenCloseEl = this.querySelectorAll(
		  "[data-ff-variants-select-open-close]"
		);

		if (ffOpenCloseEl.length > 0) {
		  return ffOpenCloseEl;
		} else {
		  throw new Error("Missing open close elements");
		}
	  })();

	  /**
	   * @type {HTMLSpanElement}
	   */
	  this.ffResultEl = (() => {
		/**
		 * @type {HTMLSpanElement | null}
		 */
		const ffResultEl = this.querySelector(
		  "[data-ff-variants-select-selection]"
		);

		if (ffResultEl) {
		  return ffResultEl;
		} else {
		  throw new Error("Missing result element");
		}
	  })();

	  /**
	   * @type {HTMLSpanElement}
	   */
	  this.ffPlaceholderEl = (() => {
		/**
		 * @type {HTMLSpanElement | null}
		 */
		const ffPlaceholderEl = this.querySelector(
		  "[data-ff-variants-select-placeholder]"
		);

		if (ffPlaceholderEl) {
		  return ffPlaceholderEl;
		} else {
		  throw new Error("Missing placeholder element");
		}
	  })();

	  this.ffOpenCloseEl.forEach((openCloseEl) =>
		openCloseEl.addEventListener("click", () => this.ffOpenClose())
	  );

	  this.ffVariantsBtn.forEach((variantBtn) => {
		variantBtn.addEventListener("click", () =>
		  this.ffInitVariant(variantBtn)
		);
	  });

      setTimeout(() => this.ffInitOnLoad(), 0); // Timeout para asegurar que el DOM está listo
	}

	ffOpenClose() {
	  if (this.ffIsOpen) {
		this.ffClose();
	  } else {
		this.ffOpen();
	  }
	}

	ffClose() {
	  this.classList.remove("ff-variants-select-open");
	  this.ffIsOpen = false;
	}

	ffOpen() {
	  this.classList.add("ff-variants-select-open");
	  this.ffIsOpen = true;
	}

	/**
	 * The dynamic select initializes after one of the variants have been clicked
	 * @param {HTMLElement} variantBtn
	 */
	ffInitVariant(variantBtn) {
	  this.ffInit();

	  const {
		ffVariantsSelectOptions,
		ffVariantFormId,
		ffVariantsSelectOverrideTextSelector,
		ffVariantsSelectBlockUntilSelectionSelector,
		ffVariantsSelectBlockUntilSelectionMsg,
	  } = variantBtn.dataset;
	  this.ffInput.setAttribute("form", ffVariantFormId || "");
	  if (ffVariantsSelectBlockUntilSelectionSelector) {
		/**
		 * @type {HTMLButtonElement | null}
		 */
		this.blockedEl = document.querySelector(
		  ffVariantsSelectBlockUntilSelectionSelector
		);

		if (this.blockedEl) {
		  this.blockedEl.style.pointerEvents = "none";
		  this.blockedElChildren = Array.from(this.blockedEl.children);
		  this.blockedElChildren.forEach(
			(child) => (child.style.display = "none")
		  );
		  this.blockedElMsgEl = document.createElement("span");
		  this.blockedElMsgEl.textContent =
			ffVariantsSelectBlockUntilSelectionMsg;
		  this.blockedEl.appendChild(this.blockedElMsgEl);
		}
	  }

	  const optionsArr = JSON.parse(ffVariantsSelectOptions || "[]"); //Modificado por itS
      optionsArr.forEach(  //Modificado por itS
		({ name, value, overrideText }) => {
		  const optionEl = document.createElement("li");
		  optionEl.textContent = name;
		  optionEl.addEventListener("click", () => {
                    this.ffSelectOption(optionEl, value, overrideText); //Modificado por itS
			/*this.ffInput.value = value;

			this.ffOptionsEl.forEach((option) => {
			  option.classList.remove("ff-variants-select_selected");
			});
			this.ffPlaceholderEl.style.display = "none";
			this.ffResultEl.textContent = optionEl.textContent;

			optionEl.classList.add("ff-variants-select_selected");
			this.classList.add("ff-variants-select-option-selected");

			if (this.blockedEl) {
			  this.blockedEl.style.pointerEvents = "";
			  this.blockedElChildren.forEach(
				(child) => (child.style.display = "")
			  );
			  this.blockedElMsgEl.remove();
			}

			if (ffVariantsSelectOverrideTextSelector) {
			  const textEl = document.querySelector(
				ffVariantsSelectOverrideTextSelector
			  );
			  if (textEl) {
				textEl.textContent = overrideText;
			  }
			}*/
		  });
		  this.ffOptionsContainerEl.appendChild(optionEl);
		  this.ffOptionsEl.push(optionEl);
		}
	  );
      // Añadido por itS: elecciona automáticamente la primera opción
      if (this.ffOptionsEl.length && optionsArr.length) {
        this.ffSelectOption(this.ffOptionsEl[0], optionsArr[0].value, optionsArr[0].overrideText);
      }
      //Fin añadido por itS
	}

	

	ffInit() {
	  if (this.blockedEl) {
		this.blockedEl.style.pointerEvents = "";
		this.blockedElChildren.forEach((child) => (child.style.display = ""));
		this.blockedElMsgEl.remove();
	  }

	  this.ffOptionsEl = [];

	  while (this.ffOptionsContainerEl.firstChild) {
		this.ffOptionsContainerEl.removeChild(
		  this.ffOptionsContainerEl.firstChild
		);
	  }

	  this.setAttribute("data-ff-variants-select-initialized", "true");
	  this.style.pointerEvents = "";
	  if (this.dataset.hasOwnProperty("ffVariantsSelectHideUntilInit")) {
		this.style.display = "";
	  }
	  this.classList.remove("ff-variants-select-option-selected");

	  this.ffPlaceholderEl.style.display = "";
	  this.ffResultEl.textContent = "";
	  this.ffInput.value = "";
	}

    //Añadido por itS
    ffInitOnLoad() {
      const selector = `[data-ff-variants-select-id='${this.id}']`;
      const tab = document.querySelector(`.ff-main-product_variant-tab.ff-main-product_variant-tab-active${selector}`);
      const tabFallback = document.querySelector(`.ff-main-product_variant-tab${selector}`);
    
      if (tab) {
        this.ffInitVariant(tab);
      } else if (tabFallback) {
        this.ffInitVariant(tabFallback);
      }
    }

    ffSelectOption(optionEl, value, overrideText) {
      this.ffInput.value = value;
    
      this.ffOptionsEl.forEach((option) => {
        option.classList.remove("ff-variants-select_selected");
      });
    
      this.ffPlaceholderEl.style.display = "none";
      this.ffResultEl.textContent = optionEl.textContent;
    
      optionEl.classList.add("ff-variants-select_selected");
      this.classList.add("ff-variants-select-option-selected");
    
      if (this.blockedEl) {
        this.blockedEl.style.pointerEvents = "";
        this.blockedElChildren.forEach(
          (child) => (child.style.display = "")
        );
        this.blockedElMsgEl.remove();
      }
    
      if (overrideText && this.ffVariantsSelectOverrideTextSelector) {
        const textEl = document.querySelector(
          this.ffVariantsSelectOverrideTextSelector
        );
        if (textEl) {
          textEl.textContent = overrideText;
        }
      }
    }
    //Fin añadido por itS

  }

  customElements.define("ff-variants-select", FfVariantsSelect);
}
